import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {ApplicationAccount} from "../types.ts";
import {useApplicationAccount} from "../hooks/useApplicationAccount.ts";
import {useParams} from "react-router-dom";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: applicationId} = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    const {
        record,
        createRecord,
    } = useApplicationAccount(applicationId);

    return (
        <FormDrawer
            record={record ?? {} as ApplicationAccount}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
